export const rentingBenefitsData = [
  {
    id: 1,
    icon: '/static/images/home/save_money.webp',
    value: 'save_money',
  },
  {
    id: 2,
    icon: '/static/images/home/save_energy.webp',
    value: 'save_energy',
  },
  {
    id: 1,
    icon: '/static/images/home/travel.webp',
    value: 'travel',
  },
];
